<template>
	<div>
		<!-- 联系我们 -->
		<el-row class="right-box-row" style="min-height: 430px;">
			<el-row class="right-box-row-title">
				<el-col :span="20">
					{{tableTitle}}
				</el-col>
				<el-col :span="4" style="color: #333333;font-size: 14px;font-weight:100;">
					点击量:{{pv.clickNum}}次
				</el-col>
			</el-row>
			<div class="loading-style-title" v-for="dept in ylqxcxLxfsList" v-loading="loading">
				<div style="border-bottom: 1px solid #cccccc">
					<div
						style="margin-top: 10px ;margin-bottom: 10px;border-left: 3px solid #40A2FF;font-weight: bold;font-size: 16px;color: #40A2FF;">
						<span style="margin-left: 15px;">{{dept.deptName}}</span>
					</div>
				</div>
				<div class="margin-top">
					<div class="margin-top style-text">
						<img src="../../../../../assets/images/ylqxcx/lxwm/lxMan.png" class="image" />
						<div class="margin-left" style="display: block;align-items: center;">联系人：</div>
						<div>{{dept.lxMan}}</div>
					</div>
					<div class="margin-top style-text">
						<img src="../../../../../assets/images/ylqxcx/lxwm/lxTel.png" class="image" />
						<div class="margin-left"><span>联系电话：</span></div>
						<div style="border: 0px solid red;">
							<el-tag v-if="!isShow" size="mini"><label style="margin-bottom: 2px;">登录后显示</label></el-tag>
						</div>

						<div v-if="isShow">
							<span>{{dept.lxTel}}</span>
						</div>
					</div>
					<div class="margin-top style-text">
						<img src="../../../../../assets/images/ylqxcx/lxwm/lxEmail.png" class="image" />
						<div class="margin-left">联系邮箱：</div>
						<div>{{dept.lxEmail}}</div>
					</div>
					<div class="margin-top style-text">
						<img src="../../../../../assets/images/ylqxcx/lxwm/lxAddress.png" class="image" />
						<div class="margin-left">联系地址：</div>
						<div>{{dept.lxAddress}}</div>
					</div>
				</div>

			</div>
		</el-row>
	</div>
</template>

<script>
	import {
		listYlqxcxLxfs,
	} from "@/api/zlts/ylqxcx/lxfs.js";
	import {
		updatePvNum,
		getPv
	} from "@/api/itempv/pv";
	export default {
		name: "Ylqxcx-lxwm",
		props: {
			tableTitle: {
				type: String,
				required: true
			},
		},
		data() {
			return {
				// 遮罩层
				loading: true,
				//是否显示联系方式
				isShow: false,
				//联系方式列表数据
				ylqxcxLxfsList: [],
				// 查询参数
				queryParams: {
					pageNum: 1,
					pageSize: 10,
					deptName: undefined,
					createTime: undefined,
					updateTime: undefined,
					ywSaveStatus: undefined,
					ywDelStatus: undefined,
					lxTel: undefined,
					lxMan: undefined,
					lxEmail: undefined,
					lxAddress: undefined
				},
				pv:{
					clickNum:undefined,
				},
			}

		},
		created() {
			this.getList();
			this.loginUser = JSON.parse(localStorage.getItem("sdtyfwpt_loginuser"));
			// console.log(this.loginUser)
			if (this.loginUser != null && this.loginUser != undefined) {
				this.isShow = true;
			}
			updatePvNum("zlts_ylqxcx_lxwm").then(response => {
				//pv 点击联系我们
			});
			this.getPvJbxx();
		},
		methods: {
			/**获取联系方式列表**/
			getPvJbxx(){
				// 获取pv点击量
				getPv("zlts_ylqxcx_lxwm").then(response => {
					this.pv = response;
				});
			},
			getList() {
				this.loading = true;
				listYlqxcxLxfs(this.queryParams).then(response => {
					this.ylqxcxLxfsList = response.rows;
					// this.total = response.total;
					this.loading = false;
				});
			},

		}
	}
</script>

<style scoped>
	.right-box-row {
		border: 1px solid #cccccc;
		padding: 0px 15px 0;
	}

	.loading-style-title {
		margin-top: 20px;
		text-align: left;
		margin-bottom: 30px;
		padding: 5px 3% 5px;
	}

	.right-box-row-title {
		padding: 15px 0;
		text-align: left;
		color: #409eff;
		font-size: 18px;
		font-weight: bold;
		border-bottom: 1px solid #cccccc;
		margin: 0px 0;
	}

	.margin-left {
		margin-left: 10px;
		display: block;
		align-items: center;
		line-height: 20px;
	}

	.margin-top {
		margin-top: 12px;
	}

	.right-box-row-title-1 {
		/* padding: 15px 0; */
		text-align: left;
		/* color: #409eff; */
		font-size: 18px;
		font-weight: bold;
		/* border-bottom: 1px solid #cccccc; */
		margin: 0;
	}

	.image {
		display: block;
		width: 20px;
		height: 20px;
	}

	.style-text {
		font-size: 13px;
		display: flex;
		justify-content: flex-start;
	}

	/deep/ .el-tag--mini {
		/* line-height:16px; */
		font-size: 13px;
	}
</style>
